import styles from './ActivityList.module.css'

export function ActivityList({ label = 'Task activity', children, className = '' }) {
  return (
    <ol className={`${styles.list} ${className}`.trim()} aria-label={label}>
      {children}
    </ol>
  )
}

export default ActivityList
